import { DeviceStationType, DeviceType } from '../device-types'

export type SelectValue = { id: string; label: string }

export const transformDeviceToSelectValue = (device: DeviceType): SelectValue => {
    return {
        id: device.uuid,
        label: `${device.device_name} : ${device.uuid}` || 'No name'
    }
}
export const transformSelectValueToDevice = (selectValue: SelectValue | undefined | null): DeviceType | null => {
    if (!selectValue) {
        return null
    }

    return {
        __typename: 'device',
        uuid: selectValue.id,
        device_name: selectValue.label || null
    }
}
